<template>
  <div id="defaultId1">
    <div class="pb20">
      <gui_card
        v-if="profitablitylist?.length > 0"
        id="ge6845"
        class="uc1096"
        :class="powerArr[0]?.hasPrivilege ? ' ' : 'vaguesuo'"
        label=""
        :isShowLabel="false"
      >
        <div :class="powerArr[0]?.hasPrivilege ? ' ' : 'vague'">
          <h2 class="operations-head-content">
            <span class="operations-head"
              >{{ $t("RatioAnalysis.ProfitabilityRatios") }}
              <!--  <svg @click="createDialog = true" t="1718848057496" class="icon" viewBox="0 0 1024 1024" version="1.1"
                style="margin-left: 20px; cursor: pointer" xmlns="http://www.w3.org/2000/svg" p-id="4445"
                width="2.28rem" height="2.28rem">
                <path
                  d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                  p-id="4446" fill="#1290C9"></path>
                <path
                  d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                  p-id="4447" fill="#1290C9"></path>
              </svg>  -->
              <i
                class="iconfont icon-rili riliicon"
                @click="createDialog = true"
              ></i>
            </span>
            <div
              class="ViewMore contclass flex_center"
              v-if="parentTablelist.length > 0"
              @click="scrollToTop('Profitability Ratios', '#Card')"
            >
              <span>{{ $t("RatioAnalysis.FinancialHighlights") }}</span>
              <div class="Financial-icon-part">
                <!-- <svg t="1749001947538" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="6416" width="20" height="20">
                  <path
                    d="M528 1024C793.6 1024 1024 793.6 1024 528 1024 230.4 793.6 0 528 0 230.4 0 0 230.4 0 528 0 793.6 230.4 1024 528 1024zM512 64c246.4 0 448 201.6 448 448s-201.6 448-448 448S64 758.4 64 512 265.6 64 512 64z"
                    fill="#FF7600" p-id="6417"></path>
                  <path d="M512 256m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z" fill="#FF7600" p-id="6418"></path>
                  <path d="M640 768h-64V384h-160v32h64v352h-64v32h224z" fill="#FF7600" p-id="6419"></path>
                </svg> -->
                <i class="iconfont icon-gantanhao1 huanggantanhaoicon"></i>

                <div class="Financial-icon-box">
                  When the subject’s data is insufficient, or you’re interested
                  in gaining more insights into your customer, this platform
                  offers a comprehensive view of all entities related to the
                  subject. This includes the subject’s company’s shareholders,
                  related companies, and more. <br />
                  By providing you with a broader perspective, this platform
                  empowers you to make more informed evaluations and gain a
                  deeper understanding of your subject.
                </div>
              </div>
            </div>
          </h2>
          <tableVue
            :profitablitylist="profitablitylist"
            :yearslist="yearslist1"
            :untia="untia"
            :nodataYears="nodataYears1"
            :createDialog="createDialog"
            @createDialogcheck="createDialogcheck"
          ></tableVue>
        </div>
      </gui_card>
      <!-- Operating Ratios -->
      <gui_card
        v-if="profitablitylist2?.length > 0"
        id="ge6845"
        class="uc1096 mt10"
        :class="powerArr[1]?.hasPrivilege ? ' ' : 'vaguesuo'"
        label=""
        :isShowLabel="false"
      >
        <div :class="powerArr[1]?.hasPrivilege ? ' ' : 'vague'">
          <h2 class="operations-head-content">
            <span class="operations-head"
              >{{ $t("RatioAnalysis.OperatingRatios") }}
              <!-- <svg @click="createDialog2 = true" t="1718848057496" class="icon" viewBox="0 0 1024 1024" version="1.1"
                style="margin-left: 20px; cursor: pointer" xmlns="http://www.w3.org/2000/svg" p-id="4445"
                width="2.28rem" height="2.28rem">
                <path
                  d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                  p-id="4446" fill="#1290C9"></path>
                <path
                  d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                  p-id="4447" fill="#1290C9"></path>
              </svg> -->
              <i
                class="iconfont icon-rili riliicon"
                @click="createDialog2 = true"
              ></i>
            </span>
            <span
              class="ViewMore contclass"
              v-if="parentTablelist.length > 0"
              @click="scrollToTop('Operating Ratios', '#Card')"
              >{{ $t("RatioAnalysis.FinancialHighlights") }}</span
            >
          </h2>
          <tableVue
            :profitablitylist="profitablitylist2"
            :yearslist="yearslist1"
            :untia="untia"
            :nodataYears="nodataYears1"
            :createDialog="createDialog2"
            @createDialogcheck="createDialogcheck2"
          >
          </tableVue>
        </div>
      </gui_card>
      <!-- Structure Ratios -->
      <gui_card
        v-if="profitablitylist3?.length > 0"
        id="ge6845"
        class="uc1096 mt10"
        label=""
        :class="powerArr[2]?.hasPrivilege ? ' ' : 'vaguesuo'"
        :isShowLabel="false"
      >
        <div :class="powerArr[2]?.hasPrivilege ? ' ' : 'vague'">
          <h2 class="operations-head-content">
            <span class="operations-head"
              >{{ $t("RatioAnalysis.StructuralRatios") }}
              <!--  <svg @click="createDialog3 = true" t="1718848057496" class="icon" viewBox="0 0 1024 1024" version="1.1"
                style="margin-left: 20px; cursor: pointer" xmlns="http://www.w3.org/2000/svg" p-id="4445"
                width="2.28rem" height="2.28rem">
                <path
                  d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                  p-id="4446" fill="#1290C9"></path>
                <path
                  d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                  p-id="4447" fill="#1290C9"></path>
              </svg> -->
              <i
                class="iconfont icon-rili riliicon"
                @click="createDialog3 = true"
              ></i>
            </span>
            <span
              class="ViewMore contclass"
              v-if="parentTablelist.length > 0"
              @click="scrollToTop('Structure Ratios', '#Card')"
              >{{ $t("RatioAnalysis.FinancialHighlights") }}</span
            >
          </h2>
          <tableVue
            :profitablitylist="profitablitylist3"
            :yearslist="yearslist1"
            :untia="untia"
            :createDialog="createDialog3"
            :nodataYears="nodataYears1"
            @createDialogcheck="createDialogcheck3"
          >
          </tableVue>
        </div>
      </gui_card>
      <!-- Productivity Ratios -->
      <gui_card
        v-if="profitablitylist4?.length > 0"
        id="ge6845"
        class="uc1096 mt10"
        label=""
        :class="powerArr[3]?.hasPrivilege ? ' ' : 'vaguesuo'"
        :isShowLabel="false"
      >
        <div :class="powerArr[3]?.hasPrivilege ? ' ' : 'vague'">
          <h2 class="operations-head-content">
            <span class="operations-head"
              >{{ $t("RatioAnalysis.ProductivityRatios") }}
              <!-- <svg @click="createDialog4 = true" t="1718848057496" class="icon" viewBox="0 0 1024 1024" version="1.1"
                style="margin-left: 20px; cursor: pointer" xmlns="http://www.w3.org/2000/svg" p-id="4445"
                width="2.28rem" height="2.28rem">
                <path
                  d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                  p-id="4446" fill="#1290C9"></path>
                <path
                  d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                  p-id="4447" fill="#1290C9"></path>
              </svg> -->
              <i
                class="iconfont icon-rili riliicon"
                @click="createDialog4 = true"
              ></i>
            </span>

            <span
              class="ViewMore contclass"
              v-if="parentTablelist.length > 0"
              @click="scrollToTop('Productivity Ratios', '#Card')"
              >{{ $t("RatioAnalysis.FinancialHighlights") }}
            </span>
          </h2>
          <tableVue
            :profitablitylist="profitablitylist4"
            :yearslist="yearslist1"
            :untia="untia"
            :createDialog="createDialog4"
            :nodataYears="nodataYears1"
            @createDialogcheck="createDialogcheck4"
          >
          </tableVue>
        </div>
      </gui_card>
      <!-- Growth Ratios -->
      <gui_card
        v-if="profitablitylist5?.length > 0"
        id="ge6845"
        class="uc1096 mt10"
        label=""
        :isShowLabel="false"
        :class="powerArr[4]?.hasPrivilege ? ' ' : 'vaguesuo'"
      >
        <div :class="powerArr[4]?.hasPrivilege ? ' ' : 'vague'">
          <h2 class="operations-head-content">
            <span class="operations-head"
              >{{ $t("RatioAnalysis.GrowthRatios") }}
              <!-- <svg @click="createDialog5 = true" t="1718848057496" class="icon" viewBox="0 0 1024 1024" version="1.1"
                style="margin-left: 20px; cursor: pointer" xmlns="http://www.w3.org/2000/svg" p-id="4445"
                width="2.28rem" height="2.28rem">
                <path
                  d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                  p-id="4446" fill="#1290C9"></path>
                <path
                  d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                  p-id="4447" fill="#1290C9"></path>
              </svg> -->
              <i
                class="iconfont icon-rili riliicon"
                @click="createDialog5 = true"
              ></i>
            </span>
            <span
              class="ViewMore contclass"
              v-if="parentTablelist.length > 0"
              @click="scrollToTop('Growth Ratios', '#Card')"
              >{{ $t("RatioAnalysis.FinancialHighlights") }}
            </span>
          </h2>
          <tableVue
            :profitablitylist="profitablitylist5"
            :yearslist="yearslist1"
            :untia="untia"
            :createDialog="createDialog5"
            :nodataYears="nodataYears1"
            @createDialogcheck="createDialogcheck5"
          >
          </tableVue>
        </div>
      </gui_card>
      <gui_card
        v-if="parentTablelist.length > 0 && Related"
        id="ge6845"
        class="uc1096 mt10"
        :class="powerArr[5]?.hasPrivilege ? ' ' : 'vaguesuo'"
        label=""
        :isShowLabel="false"
      >
        <div :class="powerArr[5]?.hasPrivilege ? ' ' : 'vague'">
          <h2 class="operations-head-content" id="Card">
            <span class="operations-head">{{
              $t("RatioAnalysis.RatioAnalysis")
            }}</span>
            <svg
              @click="Related = false"
              t="1718863593010"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4791"
              width="2.28rem"
              height="2.28rem"
            >
              <path
                d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                fill="#333333"
                p-id="4792"
              ></path>
            </svg>
          </h2>
          <!-- 关联公司 -->
          <div class="computer_right_cont_box">
            <div
              class="infinite-list-wrapper"
              v-infinite-scroll="infiniteScroll"
              style="overflow: auto"
              :infinite-scroll-disabled="false"
              :infinite-scroll-distance="5"
            >
              <div class="ecahrts-header ecahrts-header-one">
                <span class="title-left">
                  <span
                    style="cursor: pointer; margin-right: 5px; width: 450px"
                    class="line_1 relate-left"
                    >{{ $t("RatioAnalysis.CompanyName") }}</span
                  >
                </span>
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("RatioAnalysis.CompanyID") }}</span
                >
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("RatioAnalysis.Country") }}</span
                >
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("RatioAnalysis.CompanyStatus") }}</span
                >
                <span
                  class="relate-Financial"
                  style="font-family: 'Arial Bold'"
                  >{{ $t("RatioAnalysis.Relations") }}</span
                >
                <!-- <span style="
                      display: flex;
                      justify-content: flex-start;
                      width: 280px;
                    " class="line_1 relate-Financial"></span> -->
                <div class="head_loging"></div>
              </div>

              <div
                class="footer"
                v-for="(item, index) in parentTablelist"
                :key="index"
                v-loading="item.loading2"
              >
                <div class="ecahrts-header">
                  <span class="title-left">
                    <span
                      style="
                        cursor: pointer;
                        margin-right: 5px;
                        width: 450px;
                        font-family: Arial Arial;
                      "
                      class="line_1 relate-left"
                      @click="setid(item)"
                      >{{ item.nameEn }}</span
                    >
                  </span>
                  <span class="relate-Financial">{{ item.id }}</span>
                  <span class="relate-Financial">{{ item.country }}</span>
                  <span class="relate-Financial">{{ item.status }}</span>
                  <span class="line_1 relate-Financial">{{ item.typeEn }}</span>

                  <div class="head_loging">
                    <el-switch
                      active-color="#13ce66"
                      :value="loginStatus1[index]"
                      @change="loginPop(index, item.aaaid, item.nameEn)"
                    ></el-switch>
                  </div>
                </div>
                <div></div>
                <div v-if="loginStatus1[index]" class="ecahrtstu">
                  <div style="width: 100%">
                    <h2 class="operations-head">
                      {{ $t("RatioAnalysis.ProfitabilityRatios") }}
                    </h2>
                    <tabletwoVue
                      class="tableVuetwo"
                      :profitablitylist="item.relatedanylays"
                      :yearslist="item.yearslist"
                      :dia="id3a"
                      :nodataYears="item.nodataYears1"
                      :untia="untia"
                    ></tabletwoVue>
                  </div>
                  <div style="width: 100%">
                    <h2 class="operations-head">
                      {{ $t("RatioAnalysis.OperatingRatios") }}
                    </h2>
                    <tabletwoVue
                      class="tableVuetwo"
                      :profitablitylist="item.relatedanylays1"
                      :yearslist="item.yearslist"
                      :dia="id3a"
                      :nodataYears="item.nodataYears1"
                      :untia="untia"
                    >
                    </tabletwoVue>
                  </div>
                  <div style="width: 100%">
                    <h2 class="operations-head">
                      {{ $t("RatioAnalysis.StructuralRatios") }}
                    </h2>
                    <tabletwoVue
                      class="tableVuetwo"
                      :profitablitylist="item.relatedanylays2"
                      :yearslist="item.yearslist"
                      :dia="id3a"
                      :nodataYears="item.nodataYears1"
                      :untia="untia"
                    >
                    </tabletwoVue>
                  </div>
                  <div style="width: 100%">
                    <h2 class="operations-head">
                      {{ $t("RatioAnalysis.ProductivityRatios") }}
                    </h2>
                    <tabletwoVue
                      class="tableVuetwo"
                      :profitablitylist="item.relatedanylays3"
                      :yearslist="item.yearslist"
                      :dia="id3a"
                      :nodataYears="item.nodataYears1"
                      :untia="untia"
                    >
                    </tabletwoVue>
                  </div>
                  <div style="width: 100%">
                    <h2 class="operations-head">
                      {{ $t("RatioAnalysis.GrowthRatios") }}
                    </h2>
                    <tabletwoVue
                      class="tableVuetwo"
                      :profitablitylist="item.relatedanylays4"
                      :yearslist="item.yearslist"
                      :dia="id3a"
                      :nodataYears="item.nodataYears1"
                      :untia="untia"
                    >
                    </tabletwoVue>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </gui_card>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import {
  getrelatedCompanylist,
  getFinancials,
  getPerformanceSummary,
} from "@/api/companyApi";
import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import tableVue from "../Performance/components/table.vue";
import tabletwoVue from "./components/tabletwo.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import { mixins1 } from "@/mixins/index";
import { getPartPrivilege } from "@/api/companyApi";
//importEnd

export default {
  name: "",

  props: {},
  mixins: [mixins1],
  components: {
    // gui_card start
    gui_card,
    // gui_card end
    tabletwoVue,
    rectcard,
    content_text,
    tableVue,
    ReLogin,
  },
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getPerformanceSummaryList();
        this.getrelateList();
        this.getlist();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  created() {
    this.getlist();
  },
  computed: {},

  mounted() {
    this.getrelateList();
    this.getPerformanceSummaryList();
    this.getPartPrivilegeList();
  },
  data() {
    return {
      reLoginVis: false,
      Related: true,
      untia: "",
      yearslist1: [],
      nodataYears1: [],

      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      yearslist2: [],
      modulesvalue: "",
      createDialog: false,
      createDialog2: false,
      createDialog3: false,
      createDialog4: false,
      createDialog5: false,
      parentTablelist: [],
      loginStatus1: [],
      id3a: [],
      profitablitylist: [],
      profitablitylist2: [],
      profitablitylist3: [],
      profitablitylist4: [],
      profitablitylist5: [],
      companyList: [],
      noMore: false, // 控制滚动禁用
      routeLoad: false, // 控制滚动禁用
      icon: "",
      showBackToTop: false,
      newDialog: false,
      powerArr: [],
      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  methods: {
    getPartPrivilegeList() {
      getPartPrivilege({
        moduleId: this.$route.query.idpower,
      }).then((res) => {
        this.powerArr[0] = res.data.filter((item) => item.id == "456")[0];
        this.powerArr[1] = res.data.filter((item) => item.id == "457")[0];
        this.powerArr[2] = res.data.filter((item) => item.id == "458")[0];
        this.powerArr[3] = res.data.filter((item) => item.id == "459")[0];
        this.powerArr[4] = res.data.filter((item) => item.id == "460")[0];
        this.powerArr[5] = res.data.filter((item) => item.id == "461")[0];
      });
    },
    getPerformanceSummaryList() {
      getPerformanceSummary({ id3a: this.$route.query.id3a })
        .then((res) => {
          if (res.code == 200) {
            let manManagementSummary = [
              {
                name: this.$t("FinancialHighlight.Revenue"),
                id: this.$t("FinancialHighlight.Revenue"),
                num: res.data.revenue,
              },
              {
                name: this.$t("FinancialHighlight.Profit"),
                id: this.$t("FinancialHighlight.Profit"),
                num: res.data.profit,
              },
              {
                name: this.$t("FinancialHighlight.Growth"),
                id: this.$t("FinancialHighlight.Growth"),
                num: res.data.growth,
              },
              {
                name: this.$t("FinancialHighlight.Liquidity"),
                id: this.$t("FinancialHighlight.Liquidity"),
                num: res.data.liquidity,
              },
              {
                name: this.$t("FinancialHighlight.FinancialStructure"),
                id: this.$t("FinancialHighlight.FinancialStructure"),
                num: res.data.financialStructurt,
              },
              {
                name: this.$t("FinancialHighlight.CreditOpinion"),
                id: this.$t("FinancialHighlight.CreditOpinion"),
                num: res.data.creditOpinion,
              },
              {
                name: this.$t("FinancialHighlight.RiskIndicator"),
                id: this.$t("FinancialHighlight.RiskIndicator"),
                num: res.data.riskIndicatorLower,
              },
              {
                name: this.$t("FinancialHighlight.Solvencyindex"),
                id: this.$t("FinancialHighlight.Solvencyindex"),
                num: res.data.solvencyindexSI,
              },
            ];

            this.$emit("UpdatamarkTotalList", manManagementSummary);
          } else {
            this.$emit("UpdatamarkTotalList", []);
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    scrollToTop(modulesvalue, anchor) {
      this.modulesvalue = modulesvalue;
      this.Related = true;
      if (this.parentTablelist.length == 0) {
        // this.getrelateList();
      }
      const el = document.querySelector(anchor);
      el.scrollIntoView({ behavior: "smooth" });
    },
    createDialogcheck(value) {
      this.createDialog = value;
    },
    createDialogcheck2(value) {
      this.createDialog2 = value;
    },
    createDialogcheck3(value) {
      this.createDialog3 = value;
    },
    createDialogcheck4(value) {
      this.createDialog4 = value;
    },
    createDialogcheck5(value) {
      this.createDialog5 = value;
    },

    getlist() {
      const params = {
        id3a: this.$route.query.id3a,
      };
      getFinancials(params).then((res) => {
        this.loading = false;
        let data = res;
        // let data = JSON.parse(crypto.decrypt(res));

        let { ratios, years, unit, nodataYears } = data.data;
        this.profitablitylist = ratios[0].datas;
        this.nodataYears1 = nodataYears;
        this.profitablitylist2 = ratios[1].datas;
        this.profitablitylist3 = ratios[2].datas;
        this.profitablitylist4 = ratios[3].datas;
        this.profitablitylist5 = ratios[4].datas;
        this.yearslist1 = years;
        this.untia = unit;
      });
    },
    infiniteScroll() {
      this.routeLoad = false;
    },
    getrelateList() {
      getrelatedCompanylist({
        id3a: this.$route.query.id3a,
        type: 1,
        page: this.page.pageNo,
        pageSize: this.page.pageSize,
        resourceType: 1,
      }).then((res) => {
        if (res.code == 200) {
          let list = res.data.rows;
          this.parentTablelist = res.data.rows;
          this.routeLoad = false;
          this.parentTablelist.map((item) => {
            item.relatedanylays = [];
            item.relatedanylays1 = [];
            item.relatedanylays2 = [];
            item.relatedanylays3 = [];
            item.relatedanylays4 = [];
            item.loading2 = false;
            item.yearslist = [];
          });
        } else {
          this.parentTablelist = [];
        }
      });
    },
    async loginPop(index, id, nameEn) {
      this.indexclose = index;
      this.$set(this.loginStatus1, index, !this.loginStatus1[index]);
      if (this.loginStatus1[index]) {
        //   this.loading1=true
        this.parentTablelist[index].loading2 = true;
        const params = {
          id3a: id,
        };
        if (true) {
          getFinancials(params).then((res) => {
            if (!res.code) {
              this.parentTablelist[index].relatedprofitablitylist = [];
              this.parentTablelist[index].relatedprofitablitylist1 = [];
              this.parentTablelist[index].loading2 = false;
            }
            this.parentTablelist[index].loading2 = false;
            let data = res;
            // JSON.parse(crypto.decrypt());

            let { ratios, years, unit, nodataYears } = data.data;
            this.parentTablelist[index].yearslist = years;
            this.parentTablelist[index].nodataYears1 = nodataYears;
            this.id3a = years;

            this.untia = unit;
            this.parentTablelist[index].relatedanylays = ratios[0].datas;
            this.parentTablelist[index].relatedanylays1 = ratios[1].datas;
            this.parentTablelist[index].relatedanylays2 = ratios[2].datas;
            this.parentTablelist[index].relatedanylays3 = ratios[3].datas;
            this.parentTablelist[index].relatedanylays4 = ratios[4].datas;
          });
        }
      }
    },
    // insertMethod
    // srcviewscompanydetailsBackgroundSnapshotvueMethodStart
    // default
    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>
<style scoped>
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 0.2857142857142857rem;
  border-bottom-left-radius: 0.2857142857142857rem;
  border-top-right-radius: 0.2857142857142857rem;
  border-bottom-right-radius: 0.2857142857142857rem;
}

.importDetail-head {
  display: flex;
}

.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
  cursor: pointer;
}

.ViewMore {
  line-height: 32px;
  text-align: left;
  font-style: normal;
  font-size: 20px;
}
.ViewMore span {
  text-decoration-line: underline;
}

.uc1096 {
  height: 100%;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-left {
  display: flex;
  font-size: 18px;
  font-family: "Arial Bold";
  font-weight: normal;
  color: #022955;
  padding-left: 1.4285714285714286rem;
  display: flex;
  align-items: center;
  padding-bottom: 11px;
  padding-top: 11px;
  /* background-color: #f2f5f9; */
}

.title-left .relate-left {
  font-family: "Arial Bold";
}

.footer {
  padding-left: 0rem;
  overflow: hidden;
}

.ecahrts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.07142857142857142rem solid #cccccc;
}

.td {
  margin: 1.0714285714285714rem 0 0 1.7857142857142858rem;
}

.relate-left {
  /* height: 4rem; */
  font-size: 18px;
  color: #1a2332;
  /* line-height: 4rem; */
  text-align: left;
  display: flex;
  align-items: center;
  white-space: normal !important;
  word-break: keep-all;
}

.relate-Financial {
  font-size: 18px;
  color: #1a2332;
  width: 15%;
}

.ecahrts-header-one .relate-Financial,
.ecahrts-header-one .relate-left {
  font-size: 18px;
}

.computer_right_cont_box {
  margin-top: 20px;
}

.uUIRzUi {
  padding: 30px 40px;
}

.ecahrtstu {
  width: 100%;
}

.ecahrts-header-one {
  background-color: #f2f5f9;
  height: 3.57142857rem;
  /* line-height: 3.57142857rem; */
}

.Financial-icon-box {
  display: none;
  width: 500px;
  background: #ffffff;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  position: absolute;

  left: -430px;
  top: -20rem;
  z-index: 10;
  padding: 20px;
  color: #29445d;
  font-size: 18px;
}

.Financial-icon-part {
  position: relative;
  left: 5px;
}

.Financial-icon-part:hover .Financial-icon-box {
  display: block;
}

.Financial-icon-boxtwo {
  display: none;
  left: -140px;
  top: -17.1428571rem;
  line-height: 28px;
}

.Financial-icon-parttwo:hover .Financial-icon-boxtwo {
  display: block;
}

.huanggantanhaoicon {
  font-size: 30px;
  margin-left: 8px;
  color: #ff7600;
}
.riliicon {
  font-size: 32px;
  margin-left: 40px;
  color: #1290c9;
}
.cuowuicon {
  font-size: 30px;
}

@media screen and (max-width: 1920px) {
  .uUIRzUi {
    padding: 22px 30px;
  }
  .huanggantanhaoicon {
    font-size: 22px;
    margin-left: 6px;
  }
  .riliicon {
    font-size: 24px;
    margin-left: 30px;
  }
  .cuowuicon {
    font-size: 22px;
  }
  .ViewMore {
    line-height: 24px;
    font-size: 16px;
  }
  .ecahrts-header-one {
    font-size: 16px;
    height: 44px;
    line-height: 44px;
  }
  .relate-Financial {
    font-size: 16px;
    height: 44px;
    line-height: 44px;
  }

  .relate-left {
    font-size: 16px;
    min-height: 50px;
    height:auto;
    line-height: 44px;
  }
  .Financial-icon-box {
    font-size: 14px;
  }
  .title-left {
    font-size: 16px;
    line-height: 44px;
    min-height: 50px;
    height:auto;
    padding-bottom: 0px;
    padding-top: 0px;
  }
}

@media (max-width: 1439px) {
  .uUIRzUi {
    padding: 20px 26px;
  }
  .huanggantanhaoicon {
    font-size: 20px;
    margin-left: 5px;
  }
  .riliicon {
    font-size: 22px;
    margin-left: 26px;
  }
  .cuowuicon {
    font-size: 20px;
  }
  .ViewMore {
    line-height: 22px;
    font-size: 14px;
  }
  .ecahrts-header-one .relate-Financial,
  .ecahrts-header-one .relate-left {
    font-size: 14px;
  }
  .Financial-icon-box {
    font-size: 12px;
  }
}
</style>
